import React from 'react';

import icoSuccess from '../../../assets/images/dialogs/ChargeSuccessful.svg';

import CN from './ModalConfirmation.module.scss';

const ModalConfirmation = ({ title, displayImage }) => (
  <div data-bem="ModalConfirmation" className={CN.container}>
    {displayImage && (
      <div className={CN.imageContainer} data-bem="ModalConfirmation_container">
        <img src={icoSuccess} alt={title} />
      </div>
    )}

    <h2 className={CN.title} data-bem="ModalConfirmation_title">
      {title}
    </h2>
  </div>
);

export default ModalConfirmation;
